import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

/** Parent Portal branding overrides (ENR-3484). Empty/missing = Enrollio defaults. */
export interface StudioBranding {
  primaryColor?: string;
  secondaryColor?: string;
  portalDisplayName?: string;
  welcomeHeading?: string;
  welcomeSubtext?: string;
}

export interface StudioFeatures {
  _id: string;
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token: string;
  scope: string;
  userType: string;
  companyId: string;
  locationId: string;
  userId: string;
  subaccountName: string;
  consecutiveAbsencesThreshold: number;
  paymentProvider: string;
  paymentProcessingMethod: string;
  prorationMode: string;
  failedPaymentRetryCount: number;
  createdAt: string;
  updatedAt: string;
  __v: number;
  collectPaymentMethod: boolean;
  requirePaymentMethodForPaidEnrollments?: boolean;
  waitlistEnabled: boolean;
  trialBookingEnabled: boolean;
  hideSpotsRemaining: boolean;
  classPaymentDetails: boolean;
  autoFilterClassesByStudentAge: boolean;
  allowParentScheduledDrop?: boolean;
  absenceNotificationsEnabled?: boolean;
  makeupEnabled?: boolean;
  allowParentMakeupBooking?: boolean;
  ghlEmailSyncEnabled?: boolean;
  lessonReminders?: {
    daysBefore: 1 | 2 | 3;
    recipients: 'parent' | 'teacher' | 'both';
    classesEnabled: boolean;
    privateLessonsEnabled: boolean;
    trialsEnabled: boolean;
    eventsEnabled: boolean;
  };
  membershipFeeReminders?: {
    enabled: boolean;
    returningAmount: number;
    newAmount: number;
  };
  /** ENR-3484: Parent Portal color/copy overrides from feature-settings. */
  branding?: StudioBranding;
  isDemoMode?: boolean;
}

export const getWaitListStatusAPI = async () => {
  const response = await baseAPI.get<StudioFeatures>(
    '/studios/feature-settings',
  );
  return response.data;
};

export const useGetWaitListStatus = () => {
  return useQuery({
    queryKey: [KEYS.WAIT_LIST_STATUS],
    queryFn: () => getWaitListStatusAPI(),
  });
};
